module.exports = __webpack_public_path__ + "static/media/ni.e1dfe9bd.svg";